/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * PHRMPC.Manning.Web.API | v1
 * OpenAPI spec version: 1.0.0
 */
import { z as zod } from 'zod';
import { CreateTransmittalDocumentInputDto } from './createTransmittalDocumentInputDto.schema';

export const CreateTransmittalDocument = zod.object({
  "payload": zod.lazy(() => CreateTransmittalDocumentInputDto).optional()
});

export type CreateTransmittalDocument = zod.input<typeof CreateTransmittalDocument>;
export type CreateTransmittalDocumentOutput = zod.output<typeof CreateTransmittalDocument>;
